export const color = {
  primary: "#275780",
  secondary: "#ff6f4d",
};

// export const Theme = {
//   color: {
//     primary: "#275780",
//     secondary: "#ff6f4d",
//     secondaryLight: "rgba(40, 87, 129, 0.2)",
//     text: "#000",
//   },
//   boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
// };

// const uspdev = {
//   //aws_app_analytics: 'disable',
//   main_color_1: "#275780",
//   main_color_2: "#F18121",
//   platform_main_theme: "linear-gradient(#275780, #275780)",
//   button_color_web: "",
//   aws_auth_facebook: "enable",
//   aws_cloud_logic: "enable",
//   aws_cloud_logic_custom: [
//     {
//       id: "qlwvf0kwt4",
//       name: "USP-AUTHORING",
//       description: "",
//       endpoint:
//         "https://qlwvf0kwt4.execute-api.us-east-1.amazonaws.com/USP-dev",
//       region: "us-east-1",
//     },
//   ],
//   aws_cloud_logic_custom_E: [
//     {
//       id: "qlwvf0kwt4",
//       name: "USP-AUTHORING",
//       description: "",
//       endpoint:
//         "https://qlwvf0kwt4.execute-api.us-east-1.amazonaws.com/USP-dev",
//       region: "us-east-1",
//     },
//   ],
//   aws_cloud_logic_custom_name: "USP-AUTHORING",
//   aws_cloud_logic_custom_name_E: "USP-AUTHORING",
//   aws_cognito_identity_pool_id:
//     "us-east-1:46d24045-4731-4036-813e-399b36a8b1e0",
//   aws_cognito_region: "us-east-1",
//   aws_content_delivery: "enable",
//   aws_content_delivery_bucket: "ed-dev-usp",
//   aws_content_delivery_bucket_region: "us-east-1",
//   aws_content_delivery_cloudfront: "enable",
//   aws_content_delivery_cloudfront_domain: "d2n6qshoat8nng.cloudfront.net",
//   DOMAIN: "d2n6qshoat8nng.cloudfront.net",
//   aws_facebook_app_id: "281569732265049",
//   aws_facebook_app_permissions: "public_profile",
//   aws_mandatory_sign_in: "enable",
//   aws_project_region: "us-east-1",
//   aws_resource_name_prefix: "usp-resources",
//   aws_sign_in_enabled: "enable",
//   aws_user_pools: "enable",
//   aws_user_pools_id: "us-east-1_z2pRocCYo",
//   aws_user_pools_web_client_id: "1v8e76hrp2i8rj51ib8pau9s60",
//   aws_cloud_logic_custom_endpoint:
//     "https://qlwvf0kwt4.execute-api.us-east-1.amazonaws.com/",
//   aws_org_id: "USP",
//   aws_org_id_E: "USP",
//   aws_user_pools_id_E: "us-east-1_z2pRocCYo",
//   aws_user_pools_web_client_id_E: "1pd107l82ghrr0a8ptmgi9njlg",
//   aws_content_delivery_cloudfront_domain_E: "d2n6qshoat8nng.cloudfront.net",
//   aws_cloudfront_url: "d2n6qshoat8nng.cloudfront.net",
//   aws_cognito_identity_pool_id_E:
//     "us-east-1:55a63979-c796-4fc3-8fc8-140fae5debf6",
//   aws_cloud_logic_custom_endpoint_E:
//     "https://qlwvf0kwt4.execute-api.us-east-1.amazonaws.com/USP-dev/",
//   aws_ctype: 0,
//   aws_ctype_E: 0,
//   aws_cloud_logic_custom_E1: [
//     {
//       id: "qlwvf0kwt4",
//       name: "USP-PLATFORM",
//       description: "",
//       endpoint:
//         "https://qlwvf0kwt4.execute-api.us-east-1.amazonaws.com/USP-dev/",
//       region: "us-east-1",
//     },
//   ],
// };
// const usppreprod = {
//   //aws_app_analytics: 'disable',
//   main_color_1: "#275780",
//   main_color_2: "#F18121",
//   platform_main_theme: "linear-gradient(#275780, #275780)",
//   button_color_web: "",
//   aws_auth_facebook: "enable",
//   aws_cloud_logic: "enable",
//   aws_cloud_logic_custom: [
//     {
//       id: "5z3gdcxzsi",
//       name: "USP-AUTHORING",
//       description: "",
//       endpoint:
//         "https://5z3gdcxzsi.execute-api.us-east-1.amazonaws.com/usp-prod",
//       region: "us-east-1",
//     },
//   ],
//   aws_cloud_logic_custom_E: [
//     {
//       id: "qlwvf0kwt4",
//       name: "USP-AUTHORING",
//       description: "",
//       endpoint:
//         "https://qlwvf0kwt4.execute-api.us-east-1.amazonaws.com/USP-dev",
//       region: "us-east-1",
//     },
//   ],
//   aws_cloud_logic_custom_name: "USP-AUTHORING",
//   aws_cloud_logic_custom_name_E: "USP-AUTHORING",
//   aws_cognito_identity_pool_id:
//     "us-east-1:46d24045-4731-4036-813e-399b36a8b1e0",
//   aws_cognito_region: "us-east-1",
//   aws_content_delivery: "enable",
//   aws_content_delivery_bucket: "ed-p2-usp",
//   aws_content_delivery_bucket_region: "us-east-1",
//   aws_content_delivery_cloudfront: "enable",
//   aws_content_delivery_cloudfront_domain: "www.p2.usp-admin.enhanzed.com",
//   DOMAIN: "www.p2.usp-admin.enhanzed.com",
//   aws_facebook_app_id: "281569732265049",
//   aws_facebook_app_permissions: "public_profile",
//   aws_mandatory_sign_in: "enable",
//   aws_project_region: "us-east-1",
//   aws_resource_name_prefix: "usp-resources",
//   aws_sign_in_enabled: "enable",
//   aws_user_pools: "enable",
//   aws_user_pools_id: "us-east-1_CRFVTZGoS",
//   aws_user_pools_web_client_id: "5fbu4v99dqu2e6rja8pdn10s98",
//   aws_cloud_logic_custom_endpoint:
//     "https://5z3gdcxzsi.execute-api.us-east-1.amazonaws.com/",
//   aws_org_id: "USP",
//   aws_org_id_E: "USP",
//   aws_user_pools_id_E: "us-east-1_CRFVTZGoS",
//   aws_user_pools_web_client_id_E: "5fbu4v99dqu2e6rja8pdn10s98",
//   aws_content_delivery_cloudfront_domain_E: "www.p2.usp-admin.enhanzed.com",
//   aws_cloudfront_url: "www.p2.usp-admin.enhanzed.com",
//   aws_cognito_identity_pool_id_E:
//     "us-east-1:55a63979-c796-4fc3-8fc8-140fae5debf6",
//   aws_cloud_logic_custom_endpoint_E:
//     "https://5z3gdcxzsi.execute-api.us-east-1.amazonaws.com/usp-prod/",
//   aws_ctype: 0,
//   aws_ctype_E: 0,
//   aws_cloud_logic_custom_E1: [
//     {
//       id: "5z3gdcxzsi",
//       name: "USP-PLATFORM",
//       description: "",
//       endpoint:
//         "https://5z3gdcxzsi.execute-api.us-east-1.amazonaws.com/usp-prod/",
//       region: "us-east-1",
//     },
//   ],
// };
// const uspprod = {
//   //aws_app_analytics: 'disable',
//   main_color_1: "#275780",
//   main_color_2: "#F18121",
//   platform_main_theme: "linear-gradient(#275780, #275780)",
//   button_color_web: "",
//   aws_auth_facebook: "enable",
//   aws_cloud_logic: "enable",
//   aws_cloud_logic_custom: [
//     {
//       id: "utduskj2p1",
//       name: "USP-AUTHORING",
//       description: "",
//       endpoint:
//         "https://utduskj2p1.execute-api.ap-south-1.amazonaws.com/USP-prod",
//       region: "ap-south-1",
//     },
//   ],
//   aws_cloud_logic_custom_name: "USP-AUTHORING",
//   // aws_cognito_identity_pool_id:
//   //   "ap-south-1:46d24045-4731-4036-813e-399b36a8b1e0",
//   aws_cognito_region: "ap-south-1",
//   aws_content_delivery: "enable",
//   aws_content_delivery_bucket: "ed-prod-usp",
//   aws_content_delivery_bucket_region: "ap-south-1",
//   aws_content_delivery_cloudfront: "enable",
//   aws_content_delivery_cloudfront_domain: "dbotrgenun6h9.cloudfront.net",
//   DOMAIN: "dbotrgenun6h9.cloudfront.net",
//   aws_mandatory_sign_in: "enable",
//   aws_project_region: "ap-south-1",
//   aws_resource_name_prefix: "usp-resources",
//   aws_sign_in_enabled: "enable",
//   aws_user_pools: "enable",
//   aws_user_pools_id: "ap-south-1_5gB549mVF",
//   aws_user_pools_web_client_id: "6h8eqkb1hnk37s16oi15tq6nji",
//   aws_cloud_logic_custom_endpoint:
//     "https://utduskj2p1.execute-api.ap-south-1.amazonaws.com/USP-prod",
//   aws_org_id: "USP",
//   aws_cloudfront_url: "www.usp-admin.enhanzed.com",
//   aws_ctype: 0,
// };

/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

export const Theme = {
  color: {
    primary: "#093055",
    secondary: "#f18121",
    iconColor: "#1C6D9C",
    secondaryLight: "rgba(40, 87, 129, 0.2)",
    text: "#000",
    white: "#fff",
    primaryMain: "#217fb5",
  },
  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
};

const nextgen_admin_prod_usp = {
  oid: "USP",
  ctype: 0,
  curl: "d2t7b3m6w4vznt.cloudfront.net",
  apiid: "iylw9b2i52",
  title: "USP",
  mainColor1: "#304885",
  main_color_1: "#371376",
  mainColor2: "#F5B001",
  domain: "d2t7b3m6w4vznt.cloudfront.net",
  webinvokeurl: "https://iylw9b2i52.execute-api.ap-south-2.amazonaws.com/prod",
  webapiid: "iylw9b2i52",
  SCHEMA_NAME: "usp",
  defaultTenant: "Default Team",
  defaultSTID: 1,
  mt_id: 1,
  aws_project_region: "ap-south-2", // AWS Region
  aws_cloud_logic_custom: [
    {
      id: "iylw9b2i52",
      name: "prod-nextgen-admin",
      endpoint: "https://iylw9b2i52.execute-api.ap-south-2.amazonaws.com/prod",
      region: "ap-south-2",
    },
    // Add more custom APIs as needed
  ],
  aws_cloud_logic_custom_name: "prod-nextgen-admin",
  //aws_cognito_region: "eu-west-2", // Amazon Cognito region
  aws_org_id: "USP",
  aws_cognito_identity_pool_id:
    "us-east-1:f6c1c940-5cc0-4779-9813-d1f4ca08f60a",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_5gB549mVF",
  aws_user_pools_web_client_id: "6h8eqkb1hnk37s16oi15tq6nji",
  DOMAIN: "www.usp-admin.enhanzed.com",
  platform_main_theme: "linear-gradient(#275780, #275780)",
};

const nextgen_admin_dev_usp = {
  oid: "USP",
  ctype: 0,
  curl: "d24km0hu9r4cta.cloudfront.net",
  apiid: "ithxl8xba9",
  title: "USP",
  mainColor1: "#304885",
  main_color_1: "#371376",
  mainColor2: "#F5B001",
  domain: "d24km0hu9r4cta.cloudfront.net",
  webinvokeurl: "https://ithxl8xba9.execute-api.ap-south-1.amazonaws.com/dev",
  webapiid: "ithxl8xba9",
  SCHEMA_NAME: "usp",
  defaultTenant: "Default Team",
  defaultSTID: 1,
  mt_id: 1,
  aws_project_region: "ap-south-1", // AWS Region
  aws_cloud_logic_custom: [
    {
      id: "ithxl8xba9",
      name: "dev-nextgen-admin",
      endpoint: "https://ithxl8xba9.execute-api.ap-south-1.amazonaws.com/dev",
      region: "ap-south-1",
    },
    // Add more custom APIs as needed
  ],
  aws_cloud_logic_custom_name: "dev-nextgen-admin",
  aws_org_id: "USP",
  aws_cognito_identity_pool_id:
    "us-east-1:f6c1c940-5cc0-4779-9813-d1f4ca08f60a",
  aws_cognito_region: "ap-south-1",
  aws_user_pools_id: "ap-south-1_bnOwz8UMf",
  aws_user_pools_web_client_id: "1l58gbdhme0a5mvgkmstov0kll",
  DOMAIN: "www.dev-usp-admin.enabled.live",
  platform_main_theme: "linear-gradient(#275780, #275780)",
};

export default nextgen_admin_prod_usp;
